var _circle, _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M12.5715 4H14.0001C15.1047 4 16.0001 4.89543 16.0001 6V25.7143H12.5715V4Z",
    fill: "#FFB6BF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2856,
    y: 20,
    width: 5.71428,
    height: 2.28571,
    rx: 1.14286,
    fill: "#3D0E6B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2856,
    y: 14.2857,
    width: 5.71428,
    height: 2.28571,
    rx: 1.14286,
    fill: "#3D0E6B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2856,
    y: 8.57144,
    width: 5.71428,
    height: 2.28571,
    rx: 1.14286,
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.14286C8 4.51167 8.51167 4 9.14286 4H12.5714V23.4286C12.5714 24.6909 13.5948 25.7143 14.8571 25.7143H17.1429C18.4052 25.7143 19.4286 24.6909 19.4286 23.4286V4H22.8571C23.4883 4 24 4.51167 24 5.14286C24 5.77404 23.4883 6.28571 22.8571 6.28571H21.7143V23.4286C21.7143 25.9533 19.6676 28 17.1429 28H14.8571C12.3324 28 10.2857 25.9533 10.2857 23.4286V6.28571H9.14286C8.51167 6.28571 8 5.77404 8 5.14286Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExam);
export default __webpack_public_path__ + "static/media/ic_exam.cf60c8be0ee1142f47c6978dedab45ca.svg";
export { ForwardRef as ReactComponent };